export default {
  namespaced: true,

  state: {
    updatedSlots: false,
    focusedDate: new Date(),
  },

  getters: {
    updatedSlots(state) {
      return state.updatedSlots;
    },
    focusedDate(state) {
      return state.focusedDate;
    },
  },

  mutations: {
    SET_UPDATED_SLOTS(state, value) {
      state.updatedSlots = value;
    },
    SET_DATE_FOCUS(state, date) {
      state.focusedDate = date;
    },
  },

  actions: {
    updatedSlots({ commit }, value) {
      commit('SET_UPDATED_SLOTS', value);
    },
    setDateFocus({ commit }, date) {
      commit('SET_DATE_FOCUS', date);
    },
  },
};
